import { createSlice } from '@reduxjs/toolkit'
import name from './name'

// Store
export const content = createSlice({
  name,
  initialState: {
    user: undefined
  },
  reducers: {
    setUser: (state, { payload }) => {
      state.user = { ...state.user, ...payload }
    },
    resetUserDetails: (state) => {
      state.user = undefined
    }
  }
})

export const { setUser, resetUserDetails } = content.actions

export default content.reducer
